/* @ngInject */
const go = ($state,
  ownerLocal,
  routes
) => {
  const self = {}

  self.new = () => {
    $state.go(routes.consult.owner.new.path)
  }

  self.consult = (_id) => {
    ownerLocal.saveCurrentId(_id)
    $state.go(routes.consult.owner.details.path)
  }

  self.edit = (_id) => {
    ownerLocal.saveCurrentId(_id)
    $state.go(routes.consult.owner.edit.path)
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/go.service.js